module.exports = __webpack_public_path__ + "media/images/donation-popup-img-small-288f1ef57d123655b78d096b65afe1db.png";